import Functions from "./index.function";
const DefaultValueDropdown = ({
  options = [],
  selectedValue,
  handleSelect,
  defaultValue,
  label,
  iconStyle,
  icon,
  name,
  valueoption,
  valueName,
  rightIcon,
}) => {
  const {
    dropdownRef,
    isOpen,
    toggleDropdown,
    defaultSelected,
    handleOptionSelect,
  } = Functions(options, valueoption, selectedValue, handleSelect);
  return (
    <div className="relative w-full" ref={dropdownRef}>
      <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8">
        <label
          htmlFor="custom-dropdown"
          className="'xs:text-sm sm:text-base font-onestRegular text-secondary"
        >
          {label}
        </label>
      </div>
      <div
        className={`relative xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 xs:text-[15px] mb-1 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full py-3.5 rounded-full text-[#808080] transition duration-300 delay-100 border-2 ${
          isOpen ? "border-goldMetallic" : " border-transparent"
        }`}
        onClick={toggleDropdown}
      >
        <div className="flex items-center justify-between">
          <span>
            {defaultSelected ? defaultSelected[valueName] : defaultValue}
          </span>
          {icon && (
            <img
              className={`absolute left-5 3xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
              src={icon}
              alt={`${name} icon`}
            />
          )}
          <img
            className="absolute right-5 3xl:top-[30%] xs:top-4 sm:top-4 top-5 3xl:right-8 transform -translate-y-1/2 xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-5 w-6 3xl:w-7 3xl:h-6 transition-transform duration-500"
            src={rightIcon}
            alt="Dropdown icon"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        </div>
      </div>
      {isOpen && (
        <div className="absolute z-10 w-full bg-[#171717] rounded-3xl mt-2 max-h-60 overflow-y-auto scroll-container shadow-lg border-goldMetallic border-2">
          <ul className="text-[#808080]">
            {options.map((option, index) => (
              <li
                key={option[valueoption]}
                onClick={() => handleOptionSelect(option[valueoption])}
                className={`py-3 relative cursor-pointer transition duration-300 px-4 ${
                  index !== options.length - 1
                    ? "after:absolute after:bottom-0 after:left-4 after:w-11/12 after:h-[2px] after:bg-[#212121]"
                    : ""
                }`}
              >
                {option[valueName]}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
export default DefaultValueDropdown;
